<template>
  <kendo-window ref="kendoWindowRef" :title="'무인 보관함 약도'" :modal="true" :width="'600px'" style="display:none;">
    <div>
      <span>
          <img
              v-show="getLockerMapSrc !== null"
              :src="getLockerMapSrc"
          >
          <img v-show="getLockerMapSrc == null" src="@/assets/img/etners-main/aiportal_img.png">
        </span>
    </div>
  </kendo-window>
</template>
<script>
import ApiConfig from "@/api/api.config";
import ApiUtil from "@/api/api.util";

export default {
  name: "LockerMapWindow",
  props: {
    lockerId : {
      type : String,
      required : false,
      default : function (){
        return null
      }
    },
  },
  data () {
    const vm = this
    return {
      fileId: '202401161019313',
      loginUserToken : sessionStorage.getItem('loginUserToken'),
      loginUserData: JSON.parse(sessionStorage.getItem('loginUserData')),
    }
  },
  computed: {
    getLockerMapSrc () {
      const vm = this
      const imgSrc = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/locker/location/${vm.lockerId}?lutk=${vm.loginUserToken}`
      if (!!imgSrc) {
        return imgSrc
      }
      return null
    }
  },
  methods: {
    getMapImg () {
      const vm = this
      const param = {
        loginUserToken: vm.loginUserToken,
        pouchId: vm.$route.params.pouchId,
      }
      const jsonUrl = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/pouch/pouchDetail.json`

      // API 호출
      ApiUtil.post(jsonUrl, param).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          this.$Progress.fail()
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.pouchInfo = resultData.pouchInfo
        if(resultData.fileInfo !== null){
          vm.fileSrc = `${ApiConfig.eklDomain}/files/2000/${resultData.fileInfo.fileId}/0?lutk=${vm.loginUserToken}`
        }
      })
    },
  }
}
</script>

<style scoped>
</style>